module.exports = __webpack_public_path__ + "img/yuanmeng-a.f92c769.png";